/**
 * At the moment our bad words dataset is a modified
 * version of the offensive words list made available
 * from Carnegie Mellon University School of Computer
 * Science @: https://www.cs.cmu.edu/~biglou/resources/bad-words.txt
 *
 */
const badwords = [
	'aabbo',
	'aabo',
	'aabuse',
	'aackass',
	'aaddict',
	'aadfuck',
	'aalla',
	'aanal',
	'aanus',
	'aareola',
	'aargie',
	'aarse',
	'aasfuck',
	'aass',
	'aassas',
	'aassaul',
	'aasse',
	'aasses',
	'aassfuc',
	'aassha',
	'aasshat',
	'aasshol',
	'aasshor',
	'aasskis',
	'aasslic',
	'aassma',
	'aassman',
	'aasswip',
	'aasyslut',
	'aatass',
	'aatfuck',
	'aatpussy',
	'abbbo',
	'abbo',
	'abboo',
	'abbuse',
	'abo',
	'aboo',
	'abortion',
	'abuse',
	'abusee',
	'abusse',
	'abuuse',
	'acckass',
	'acefucker',
	'ackaass',
	'ackass',
	'ackasss',
	'ackkass',
	'ackshit',
	'adddict',
	'addfuck',
	'addicct',
	'addict',
	'addicts',
	'addictt',
	'addiict',
	'adffuck',
	'adfucck',
	'adfuck',
	'adfuckk',
	'adfuuck',
	'adult',
	'africa',
	'african',
	'alla',
	'allaa',
	'alligatorbait',
	'allla',
	'amateur',
	'american',
	'anaal',
	'anal',
	'analannie',
	'anall',
	'analsex',
	'andnigger',
	'angry',
	'annal',
	'annus',
	'annyfucker',
	'anus',
	'anuss',
	'anuus',
	'arab',
	'arabs',
	'areeola',
	'areola',
	'areolaa',
	'areolla',
	'areoola',
	'arggie',
	'argie',
	'argiee',
	'argiie',
	'aroused',
	'arrgie',
	'arrse',
	'arse',
	'arsee',
	'arsehole',
	'arsse',
	'asasasasasshole',
	'asasasasshole',
	'asasasshole',
	'asasshole',
	'asffuck',
	'asfucck',
	'asfuck',
	'asfucker',
	'asfuckk',
	'asfuuck',
	'asian',
	'ass',
	'assaas',
	'assaaul',
	'assaolt',
	'assas',
	'assass',
	'assassen',
	'assassenate',
	'assassenateon',
	'assassi',
	'assassin',
	'assassinat',
	'assassinata',
	'assassinate',
	'assassinatio',
	'assassination',
	'assassinatiun',
	'assaul',
	'assaull',
	'assault',
	'assauul',
	'assbaggar',
	'assbagge',
	'assbagger',
	'assblastar',
	'assblaste',
	'assblaster',
	'assclow',
	'assclown',
	'asscluwn',
	'asscowbo',
	'asscowboy',
	'asscuwbuy',
	'asse',
	'assee',
	'assees',
	'asses',
	'assess',
	'assffuc',
	'assfock',
	'assfocker',
	'assfuc',
	'assfucc',
	'assfuck',
	'assfuckar',
	'assfucke',
	'assfucker',
	'assfuuc',
	'assha',
	'asshaa',
	'asshaat',
	'asshat',
	'asshatt',
	'asshha',
	'asshhat',
	'asshhhhhhole',
	'asshhhhhole',
	'asshhhhole',
	'asshhhole',
	'asshhol',
	'asshhole',
	'asshhor',
	'asshohohohohole',
	'asshohohohole',
	'asshohohole',
	'asshohole',
	'asshol',
	'asshola',
	'assholas',
	'asshole',
	'assholele',
	'assholelele',
	'assholelelele',
	'assholelelelele',
	'assholes',
	'assholl',
	'assholle',
	'asshollle',
	'assholllle',
	'asshollllle',
	'assholllllle',
	'assholole',
	'asshololole',
	'assholololole',
	'asshololololole',
	'asshool',
	'asshoor',
	'asshor',
	'asshora',
	'asshore',
	'asshorr',
	'asshshole',
	'asshshshole',
	'asshshshshole',
	'asshshshshshole',
	'asshule',
	'asshules',
	'asshure',
	'assjockay',
	'assjocke',
	'assjockey',
	'assjuckey',
	'asskess',
	'asskesser',
	'asskiis',
	'asskis',
	'asskiss',
	'asskissar',
	'asskisse',
	'asskisser',
	'asskkis',
	'assklow',
	'assklown',
	'asskluwn',
	'assleck',
	'asslecker',
	'asslic',
	'asslicc',
	'asslick',
	'asslickar',
	'asslicke',
	'asslicker',
	'assliic',
	'assllic',
	'asslovar',
	'asslove',
	'asslover',
	'assluver',
	'assma',
	'assmaa',
	'assmaan',
	'assman',
	'assmann',
	'assmma',
	'assmman',
	'assmonch',
	'assmoncher',
	'assmonkay',
	'assmonke',
	'assmonkey',
	'assmunc',
	'assmunch',
	'assmunchar',
	'assmunche',
	'assmuncher',
	'assmunkey',
	'asspackar',
	'asspacke',
	'asspacker',
	'assperate',
	'asspirat',
	'asspirata',
	'asspirate',
	'asspoppies',
	'asspuppees',
	'asspuppias',
	'asspuppie',
	'asspuppies',
	'assrangar',
	'assrange',
	'assranger',
	'asss',
	'asssas',
	'asssaul',
	'assse',
	'assses',
	'asssfuc',
	'asssha',
	'assshat',
	'assshol',
	'assshole',
	'assshor',
	'assskis',
	'assslic',
	'asssma',
	'asssman',
	'asssshole',
	'assssshole',
	'asssssshole',
	'assssssshole',
	'asssssssshole',
	'asssssssssshole',
	'assswip',
	'asswepe',
	'asswhor',
	'asswhora',
	'asswhore',
	'asswhure',
	'asswiip',
	'asswip',
	'asswipa',
	'asswipe',
	'asswipp',
	'asswwip',
	'astfuck',
	'astybitch',
	'astyslut',
	'astywhore',
	'aswhore',
	'asyslut',
	'ataass',
	'atass',
	'atasss',
	'atffuck',
	'atfucck',
	'atfuck',
	'atfucker',
	'atfuckk',
	'atfuuck',
	'athletesfoot',
	'atnigga',
	'atpussy',
	'attack',
	'attass',
	'attfuck',
	'australian',
	'aymuthafuckinwhore',
	'baabe',
	'baalls',
	'baarf',
	'baast',
	'baastard',
	'bababababastard',
	'babababastard',
	'bababastard',
	'babastard',
	'babbe',
	'babe',
	'babee',
	'babies',
	'backdoor',
	'backdoorman',
	'backseat',
	'badfuck',
	'balllicker',
	'ballls',
	'balls',
	'ballsack',
	'ballss',
	'banging',
	'baptist',
	'barelylegal',
	'barf',
	'barface',
	'barff',
	'barfface',
	'barrf',
	'basssssstard',
	'bassssstard',
	'basssstard',
	'bassstard',
	'basst',
	'basstard',
	'bast',
	'bastaard',
	'bastard',
	'bastardd',
	'bastarddd',
	'bastardddd',
	'bastarddddd',
	'bastardddddd',
	'bastardrd',
	'bastardrdrd',
	'bastardrdrdrd',
	'bastardrdrdrdrd',
	'bastarrd',
	'bastt',
	'basttard',
	'bazongas',
	'bazooms',
	'bbabe',
	'bballs',
	'bbarf',
	'bbast',
	'bbastard',
	'bbbastard',
	'bbbbastard',
	'bbbbbastard',
	'bbbbbbastard',
	'bbbbbbitch',
	'bbbbbitch',
	'bbbbitch',
	'bbbitch',
	'bbeaner',
	'bbeast',
	'bbegass',
	'bbiatch',
	'bbigass',
	'bbigger',
	'bbiitch',
	'bbitcch',
	'bbitch',
	'bbitche',
	'bbitchh',
	'bbitchi',
	'bbitchy',
	'bbiteme',
	'bbittch',
	'bblow',
	'bboang',
	'bbohunk',
	'bboner',
	'bboob',
	'bboobs',
	'bbooby',
	'bboody',
	'bboom',
	'bboong',
	'bboonga',
	'bboonie',
	'bbooty',
	'bbra',
	'bbreast',
	'bbugger',
	'bbunga',
	'bburn',
	'bbyatch',
	'beaaner',
	'beaast',
	'beaneer',
	'beaner',
	'beanerr',
	'beanner',
	'beasst',
	'beast',
	'beastality',
	'beastial',
	'beastiality',
	'beastt',
	'beat-off',
	'beatoff',
	'beatyourmeat',
	'bedfuck',
	'beeaner',
	'beeast',
	'beegass',
	'begaass',
	'begass',
	'begasss',
	'begbastard',
	'beggass',
	'bestial',
	'bestiality',
	'bi',
	'bi-sexual',
	'biaatch',
	'biatcch',
	'biatch',
	'biatchh',
	'biattch',
	'bibibibibitch',
	'bibibibitch',
	'bibibitch',
	'bibitch',
	'bible',
	'bicurious',
	'bigaass',
	'bigass',
	'bigasss',
	'bigbastard',
	'bigbutt',
	'biggass',
	'biggeer',
	'bigger',
	'biggerr',
	'biggger',
	'biiatch',
	'biigass',
	'biigger',
	'biitch',
	'biitche',
	'biitchh',
	'biitchi',
	'biitchy',
	'biiteme',
	'bisexual',
	'bitcch',
	'bitcche',
	'bitcchh',
	'bitcchi',
	'bitcchy',
	'bitch',
	'bitchar',
	'bitchas',
	'bitchaz',
	'bitchch',
	'bitchchch',
	'bitchchchch',
	'bitchchchchch',
	'bitche',
	'bitchee',
	'bitcher',
	'bitches',
	'bitchez',
	'bitchh',
	'bitchhe',
	'bitchhh',
	'bitchhhh',
	'bitchhhhh',
	'bitchhhhhh',
	'bitchhi',
	'bitchhy',
	'bitchi',
	'bitchii',
	'bitchin',
	'bitching',
	'bitchsla',
	'bitchslap',
	'bitchslep',
	'bitchy',
	'bitchyy',
	'biteeme',
	'biteme',
	'bitemee',
	'bitemme',
	'bittch',
	'bittche',
	'bittchh',
	'bittchi',
	'bittchy',
	'bitteme',
	'blackout',
	'blacks',
	'blind',
	'bllow',
	'bloow',
	'blow',
	'blowjob',
	'bloww',
	'boaang',
	'boang',
	'boangg',
	'boanng',
	'bohhunk',
	'bohunk',
	'bohunkk',
	'bohunnk',
	'bohuunk',
	'bollick',
	'bollock',
	'bollshit',
	'bomb',
	'bombers',
	'bombing',
	'bombs',
	'bomd',
	'bondage',
	'boneer',
	'boner',
	'bonerr',
	'booang',
	'boob',
	'boobb',
	'boobbs',
	'boobby',
	'boobies',
	'boobs',
	'boobss',
	'booby',
	'boobyy',
	'booddy',
	'boody',
	'boodyy',
	'boohunk',
	'boom',
	'boomm',
	'booner',
	'boong',
	'boonga',
	'boongaa',
	'boongg',
	'boongga',
	'boonie',
	'booniee',
	'booniie',
	'boonng',
	'boonnga',
	'boonnie',
	'booob',
	'booobs',
	'boooby',
	'booody',
	'booom',
	'booong',
	'booonga',
	'booonie',
	'boooty',
	'bootty',
	'booty',
	'bootycall',
	'bootyy',
	'bountybar',
	'bra',
	'braa',
	'brea5t',
	'breaast',
	'breasst',
	'breast',
	'breastjob',
	'breastlover',
	'breastman',
	'breastt',
	'breeast',
	'brothel',
	'brra',
	'brreast',
	'buggeer',
	'bugger',
	'buggered',
	'buggerr',
	'buggery',
	'buggger',
	'bullcrap',
	'bulldike',
	'bulldyke',
	'bullshit',
	'bulshit',
	'bumblafuck',
	'bumblefuck',
	'bumfuck',
	'bunga',
	'bungaa',
	'bungga',
	'bunghole',
	'bunnga',
	'buried',
	'burn',
	'burnn',
	'burrn',
	'but-fuck',
	'but-fucker',
	'but-fuckers',
	'butchbabes',
	'butchdike',
	'butchdyke',
	'butfuck',
	'butfucker',
	'butfuckers',
	'butt-bang',
	'butt-fuck',
	'butt-fuckar',
	'butt-fuckars',
	'butt-fucke',
	'butt-fucker',
	'butt-fuckers',
	'buttbang',
	'buttface',
	'buttfuck',
	'buttfuckar',
	'buttfuckars',
	'buttfucke',
	'buttfucker',
	'buttfuckers',
	'butthead',
	'buttman',
	'buttmunch',
	'buttmuncher',
	'buttpirate',
	'buttplug',
	'buttstain',
	'buugger',
	'buunga',
	'buurn',
	'byaatch',
	'byatcch',
	'byatch',
	'byatchh',
	'byattch',
	'byyatch',
	'caacker',
	'caccker',
	'cackeer',
	'cacker',
	'cackerr',
	'cackker',
	'cameljockey',
	'cameltoe',
	'canadian',
	'cancer',
	'carpetmuncher',
	'carruth',
	'catholic',
	'catholics',
	'ccacker',
	'ccccccunt',
	'cccccunt',
	'ccccunt',
	'cccum',
	'cccunnt',
	'cccunt',
	'cccuntt',
	'cccuunt',
	'cchav',
	'cchink',
	'cchinky',
	'cchoad',
	'cchode',
	'cclit',
	'ccock',
	'ccocky',
	'ccoitus',
	'ccolor',
	'ccoolie',
	'ccooly',
	'ccrabs',
	'ccreamy',
	'ccrotch',
	'ccuant',
	'ccucunt',
	'ccum',
	'ccumm',
	'ccummer',
	'ccunn',
	'ccunnt',
	'ccunntt',
	'ccunt',
	'ccuntnt',
	'ccuntt',
	'ccunttt',
	'ccuum',
	'ccuunt',
	'cemetery',
	'chaav',
	'chav',
	'chavv',
	'cherrypopper',
	'chhav',
	'chhink',
	'chhinky',
	'chhoad',
	'chhode',
	'chickslick',
	'chiink',
	'chiinky',
	`children's`,
	'chinaman',
	'chinamen',
	'chinese',
	'chink',
	'chinkk',
	'chinkky',
	'chinky',
	'chinkyy',
	'chinnk',
	'chinnky',
	'choaad',
	'choad',
	'choadd',
	'chodde',
	'chode',
	'chodee',
	'chooad',
	'choode',
	'christ',
	'cigarette',
	'cigs',
	'clamdigger',
	'clamdiver',
	'cliit',
	'clit',
	'clitoris',
	'clitt',
	'cllit',
	'clogwog',
	'cocaine',
	'cocck',
	'coccky',
	'cock',
	'cockblock',
	'cockblocker',
	'cockcowboy',
	'cockfight',
	'cockhead',
	'cockk',
	'cockknob',
	'cockky',
	'cocklicker',
	'cocklover',
	'cocknob',
	'cockqueen',
	'cockrider',
	'cocksman',
	'cocksmith',
	'cocksmoker',
	'cocksucer',
	'cocksuck',
	'cocksucked',
	'cocksucker',
	'cocksucking',
	'cocktail',
	'cocktease',
	'cocky',
	'cockyy',
	'coiitus',
	'coittus',
	'coitus',
	'coituss',
	'coituus',
	'collor',
	'coloor',
	'color',
	'colored',
	'colorr',
	'coloured',
	'commie',
	'communist',
	'condom',
	'conservative',
	'conspiracy',
	'coock',
	'coocky',
	'cooitus',
	'coolie',
	'cooliee',
	'cooliie',
	'coollie',
	'coolly',
	'coolor',
	'cooly',
	'coolyy',
	'coondog',
	'cooolie',
	'coooly',
	'copulate',
	'cornhole',
	'corruption',
	'cra5h',
	'craabs',
	'crabbs',
	'crabs',
	'crabss',
	'crack',
	'crack-whore',
	'crackpipe',
	'crackwhore',
	'crap',
	'crapola',
	'crapper',
	'crappy',
	'crash',
	'creaamy',
	'creammy',
	'creamy',
	'creamyy',
	'creck-whore',
	'creckwhore',
	'creeamy',
	'crime',
	'crimes',
	'criminal',
	'criminals',
	'crootch',
	'crotcch',
	'crotch',
	'crotchh',
	'crotchjockey',
	'crotchmonkey',
	'crotchrot',
	'crottch',
	'crrabs',
	'crreamy',
	'crrotch',
	'cuaant',
	'cuannt',
	'cuant',
	'cuantt',
	'cuccunt',
	'cucucucucunt',
	'cucucucunt',
	'cucucunt',
	'cucunnt',
	'cucunt',
	'cucuntt',
	'cucuunt',
	'cum',
	'cumbubble',
	'cumfest',
	'cumjockey',
	'cumm',
	'cummeer',
	'cummer',
	'cummerr',
	'cumming',
	'cummm',
	'cummmer',
	'cumquat',
	'cumqueen',
	'cumshot',
	'cunilingus',
	'cunillingus',
	'cunn',
	'cunnilingus',
	'cunnn',
	'cunnnt',
	'cunnntt',
	'cunnt',
	'cunntnt',
	'cunntt',
	'cunnttt',
	'cunt',
	'cuntayad',
	'cunteye',
	'cunteyed',
	'cuntfuc',
	'cuntfuck',
	'cuntfuckar',
	'cuntfucke',
	'cuntfucker',
	'cuntleck',
	'cuntleckeng',
	'cuntlecker',
	'cuntlick',
	'cuntlickar',
	'cuntlicker',
	'cuntlicking',
	'cuntnnt',
	'cuntnt',
	'cuntntnt',
	'cuntntntnt',
	'cuntntntntnt',
	'cuntntt',
	'cuntsuckar',
	'cuntsucke',
	'cuntsucker',
	'cuntt',
	'cunttnt',
	'cunttt',
	'cuntttt',
	'cunttttt',
	'cuntttttt',
	'cuuant',
	'cuucunt',
	'cuum',
	'cuumm',
	'cuummer',
	'cuunn',
	'cuunnt',
	'cuunntt',
	'cuunt',
	'cuuntnt',
	'cuuntt',
	'cuunttt',
	'cuuum',
	'cuuunt',
	'cybersex',
	'cyberslimer',
	'daago',
	'daammit',
	'daamn',
	'daamnit',
	'daarkie',
	'daarky',
	'daggo',
	'dago',
	'dagoo',
	'dahmer',
	'dammiit',
	'dammit',
	'dammitt',
	'dammmit',
	'dammn',
	'dammnit',
	'damn',
	'damnation',
	'damniit',
	'damnit',
	'damnitt',
	'damnn',
	'damnnit',
	'darkie',
	'darkiee',
	'darkiie',
	'darkkie',
	'darkky',
	'darky',
	'darkyy',
	'darrkie',
	'darrky',
	'datnigg',
	'datnigga',
	'ddago',
	'ddammit',
	'ddamn',
	'ddamnit',
	'ddarkie',
	'ddarky',
	'dddyke',
	'ddego',
	'ddemon',
	'ddevil',
	'ddickma',
	'ddickwa',
	'ddiddle',
	'ddidick',
	'ddie',
	'ddike',
	'ddildo',
	'ddink',
	'ddive',
	'ddix',
	'ddong',
	'ddoodoo',
	'ddrunk',
	'ddyefly',
	'ddyke',
	'ddykee',
	'ddykke',
	'ddyyke',
	'dead',
	'deapthroat',
	'death',
	'deego',
	'deemon',
	'deepthroat',
	'deevil',
	'defecate',
	'deggo',
	'dego',
	'degoo',
	'demon',
	'demonn',
	'demoon',
	'deposit',
	'destroy',
	'deth',
	'detnigge',
	'deviil',
	'devil',
	'devill',
	'devilworshipper',
	'devvil',
	'dicckma',
	'dicckwa',
	'dickbrai',
	'dickbrain',
	'dickbrein',
	'dickforbrain',
	'dickforbrains',
	'dickforbreins',
	'dickfurbrains',
	'dickhaad',
	'dickhea',
	'dickhead',
	'dickheed',
	'dickkma',
	'dickkwa',
	'dickless',
	'dicklic',
	'dicklick',
	'dicklickar',
	'dicklicke',
	'dicklicker',
	'dickma',
	'dickmaa',
	'dickman',
	'dickmen',
	'dickmma',
	'dickwa',
	'dickwaa',
	'dickwaad',
	'dickwad',
	'dickwed',
	'dickwee',
	'dickweed',
	'dickwwa',
	'didddle',
	'diddick',
	'diddle',
	'diddlee',
	'diddlle',
	'didicck',
	'didick',
	'didickk',
	'dididick',
	'didididick',
	'dididididick',
	'didiick',
	'die',
	'died',
	'diee',
	'dies',
	'diickma',
	'diickwa',
	'diiddle',
	'diidick',
	'diie',
	'diike',
	'diildo',
	'diink',
	'diive',
	'diix',
	'dike',
	'dikee',
	'dikke',
	'dilddo',
	'dildo',
	'dildoo',
	'dilldo',
	'dingleberry',
	'dink',
	'dinkk',
	'dinnk',
	'dipshit',
	'dipstick',
	'dirty',
	'disease',
	'diseases',
	'disturbed',
	'dive',
	'divee',
	'divve',
	'dix',
	'dixiedike',
	'dixiedyke',
	'dixx',
	'doggiestyle',
	'doggystyle',
	'dombass',
	'dombbitch',
	'dong',
	'dongg',
	'donng',
	'doo-doo',
	'dooddoo',
	'doodoo',
	'doodooo',
	'doom',
	'doong',
	'dooodoo',
	'dope',
	'dragqueen',
	'dragqween',
	'dripdick',
	'drrunk',
	'drug',
	'drunk',
	'drunken',
	'drunkk',
	'drunnk',
	'druunk',
	'dumb',
	'dumbass',
	'dumbbitch',
	'dumbfuck',
	'dumbitch',
	'dyeefly',
	'dyeffly',
	'dyeflly',
	'dyefly',
	'dyeflyy',
	'dyke',
	'dykee',
	'dykeee',
	'dykke',
	'dykkee',
	'dykkke',
	'dyyefly',
	'dyyke',
	'dyykee',
	'dyykke',
	'dyyyke',
	'eaatme',
	'eadfuck',
	'easyslut',
	'eatballs',
	'eatme',
	'eatmee',
	'eatmme',
	'eatpussy',
	'eattme',
	'eccum',
	'ecstacy',
	'ecum',
	'ecumm',
	'ecuum',
	'eeatme',
	'eecum',
	'eenema',
	'eenemy',
	'eerect',
	'eero',
	'eesyslut',
	'eetpussy',
	'ejaculate',
	'ejaculated',
	'ejaculating',
	'ejaculation',
	'eneema',
	'eneemy',
	'enema',
	'enemaa',
	'enemma',
	'enemmy',
	'enemy',
	'enemyy',
	'ennema',
	'ennemy',
	'entafuck',
	'entheass',
	'erecct',
	'erect',
	'erection',
	'erectt',
	'ereect',
	'ero',
	'eroo',
	'errect',
	'erro',
	'escort',
	'essfuck',
	'essfucker',
	'esswhore',
	'ethiopian',
	'ethnic',
	'european',
	'evl',
	'excrement',
	'execute',
	'executed',
	'execution',
	'executioner',
	'explosion',
	'exwhore',
	'faaeces',
	'faag',
	'faaggin',
	'faaggo',
	'faaggot',
	'faaggut',
	'faaging',
	'faago',
	'faagot',
	'faagut',
	'faairy',
	'faart',
	'faarted',
	'faarty',
	'faatass',
	'faatso',
	'facafuckar',
	'facefucke',
	'facefucker',
	'faecces',
	'faecees',
	'faeces',
	'faecess',
	'faeeces',
	'fafafafaggot',
	'fafafaggot',
	'fafaggot',
	'fag',
	'fagagagaggot',
	'fagagaggot',
	'fagaggot',
	'faggeng',
	'faggggggggot',
	'faggggggot',
	'fagggggot',
	'faggggot',
	'fagggin',
	'fagggo',
	'fagggot',
	'fagggut',
	'faggiin',
	'faggin',
	'fagging',
	'fagginn',
	'faggo',
	'faggogogogot',
	'faggogogot',
	'faggogot',
	'faggoo',
	'faggoot',
	'faggot',
	'faggotot',
	'faggototot',
	'faggotototot',
	'faggott',
	'faggottt',
	'faggotttt',
	'faggottttt',
	'faggut',
	'faggutt',
	'fagguut',
	'fagiing',
	'faging',
	'fagingg',
	'faginng',
	'fago',
	'fagoo',
	'fagoot',
	'fagot',
	'fagott',
	'fagut',
	'fagutt',
	'faguut',
	'faiiry',
	'failed',
	'failure',
	'fairies',
	'fairry',
	'fairy',
	'fairyy',
	'fannyfuckar',
	'fannyfucke',
	'fannyfucker',
	'fanyfucker',
	'farrt',
	'farrted',
	'farrty',
	'fart',
	'farted',
	'fartedd',
	'farteed',
	'farting',
	'fartt',
	'fartted',
	'fartty',
	'farty',
	'fartyy',
	'fastfuck',
	'fat',
	'fataass',
	'fatah',
	'fatass',
	'fatasss',
	'fatfuck',
	'fatfuckar',
	'fatfucke',
	'fatfucker',
	'fatso',
	'fatsoo',
	'fatsso',
	'fattass',
	'fattso',
	'fcckcum',
	'fckccum',
	'fckcum',
	'fckcumm',
	'fckcuum',
	'fckkcum',
	'fecces',
	'fecees',
	'fecefucker',
	'feces',
	'fecess',
	'feeces',
	'feelch',
	'feeltch',
	'feetish',
	'felatio',
	'felcch',
	'felch',
	'felcher',
	'felchh',
	'felching',
	'fellatio',
	'fellch',
	'felltch',
	'feltcch',
	'feltch',
	'feltcher',
	'feltchh',
	'feltching',
	'felttch',
	'fengerfuck',
	'fengerfucked',
	'fengerfuckeng',
	'fengerfucker',
	'fengerfuckers',
	'fennyfucker',
	'festfuck',
	'festfucked',
	'festfuckeng',
	'festfucker',
	'fetfuck',
	'fetfucker',
	'fetiish',
	'fetish',
	'fetishh',
	'fetissh',
	'fettish',
	'ffaeces',
	'ffag',
	'ffaggin',
	'ffaggo',
	'ffaggot',
	'ffaggut',
	'ffaging',
	'ffago',
	'ffagot',
	'ffagut',
	'ffairy',
	'ffart',
	'ffarted',
	'ffarty',
	'ffatass',
	'ffatso',
	'ffckcum',
	'ffeces',
	'ffelch',
	'ffeltch',
	'ffetish',
	'fffaggot',
	'ffffaggot',
	'fffffaggot',
	'ffffffuck',
	'fffffuck',
	'ffffuck',
	'fffucck',
	'fffuck',
	'fffuckk',
	'fffuuck',
	'fflange',
	'ffloo',
	'fflydie',
	'fflydye',
	'ffok',
	'ffondle',
	'ffore',
	'fforni',
	'ffubar',
	'ffuc',
	'ffucck',
	'ffuck',
	'ffucka',
	'ffuckad',
	'ffuckar',
	'ffuckba',
	'ffuckck',
	'ffucke',
	'ffucked',
	'ffucken',
	'ffucker',
	'ffucket',
	'ffuckhe',
	'ffucki',
	'ffuckin',
	'ffuckit',
	'ffuckk',
	'ffuckkk',
	'ffuckma',
	'ffuckme',
	'ffuckof',
	'ffuckpi',
	'ffucks',
	'ffuckyo',
	'ffufuck',
	'ffugly',
	'ffuk',
	'ffuks',
	'ffuuck',
	'fight',
	'filipina',
	'filipino',
	'fingarfuck',
	'fingarfuckad',
	'fingarfuckar',
	'fingarfuckars',
	'fingarfucking',
	'fingerfood',
	'fingerfuck',
	'fingerfucked',
	'fingerfucker',
	'fingerfuckers',
	'fingerfucking',
	'fire',
	'firing',
	'fistfuck',
	'fistfuckad',
	'fistfuckar',
	'fistfucked',
	'fistfucker',
	'fistfucking',
	'fisting',
	'flaange',
	'flange',
	'flangee',
	'flangge',
	'flannge',
	'flasher',
	'flatulence',
	'fllange',
	'flloo',
	'fllydie',
	'fllydye',
	'floo',
	'flooo',
	'flyddie',
	'flyddye',
	'flydie',
	'flydiee',
	'flydiie',
	'flydye',
	'flydyee',
	'flydyye',
	'flyydie',
	'flyydye',
	'fockingbitch',
	'fockwhore',
	'fok',
	'fokk',
	'fonddle',
	'fondle',
	'fondlee',
	'fondlle',
	'fonndle',
	'fook',
	'foondle',
	'foorni',
	'footaction',
	'footfuck',
	'footfuckar',
	'footfucke',
	'footfucker',
	'footlicker',
	'footstar',
	'fore',
	'foreskin',
	'forni',
	'fornicate',
	'fornii',
	'fornni',
	'forre',
	'forrni',
	'fotfuck',
	'fotfucker',
	'foursome',
	'fourtwenty',
	'fraafuck',
	'fraakfuck',
	'fraakyfuckar',
	'fraud',
	'freakfuck',
	'freakyfucke',
	'freakyfucker',
	'freefuck',
	'freekfuck',
	'freekyfucker',
	'frefuck',
	'fu',
	'fubaar',
	'fubar',
	'fubarr',
	'fubbar',
	'fuc',
	'fucc',
	'fuccck',
	'fucck',
	'fuccka',
	'fucckad',
	'fucckar',
	'fucckba',
	'fucckck',
	'fuccke',
	'fuccked',
	'fuccken',
	'fuccker',
	'fuccket',
	'fucckhe',
	'fuccki',
	'fucckin',
	'fucckit',
	'fucckk',
	'fucckkk',
	'fucckma',
	'fucckme',
	'fucckof',
	'fucckpi',
	'fuccks',
	'fucckyo',
	'fuck',
	'fucka',
	'fuckaa',
	'fuckaad',
	'fuckaar',
	'fuckabl',
	'fuckabla',
	'fuckable',
	'fuckad',
	'fuckadd',
	'fuckadup',
	'fuckar',
	'fuckarr',
	'fuckars',
	'fuckba',
	'fuckbaa',
	'fuckbag',
	'fuckbba',
	'fuckbeg',
	'fuckbudd',
	'fuckbuddy',
	'fuckbudy',
	'fuckcck',
	'fuckck',
	'fuckckck',
	'fuckckckck',
	'fuckckckckck',
	'fuckckk',
	'fucke',
	'fuckeble',
	'fucked',
	'fuckedd',
	'fuckedu',
	'fuckedup',
	'fuckee',
	'fuckeed',
	'fuckeen',
	'fuckeer',
	'fuckeet',
	'fucken',
	'fuckena',
	'fuckeng',
	'fuckengbetch',
	'fuckenn',
	'fuckennuts',
	'fuckenreght',
	'fucker',
	'fuckerr',
	'fuckers',
	'fucket',
	'fuckett',
	'fuckfac',
	'fuckfaca',
	'fuckface',
	'fuckfast',
	'fuckfece',
	'fuckfes',
	'fuckfest',
	'fuckfraak',
	'fuckfrea',
	'fuckfreak',
	'fuckfreek',
	'fuckfreend',
	'fuckfriand',
	'fuckfrien',
	'fuckfriend',
	'fuckhaad',
	'fuckhar',
	'fuckhe',
	'fuckhea',
	'fuckhead',
	'fuckhee',
	'fuckheed',
	'fuckher',
	'fuckhhe',
	'fucki',
	'fuckii',
	'fuckiin',
	'fuckiit',
	'fuckin',
	'fuckina',
	'fuckine',
	'fucking',
	'fuckingbitc',
	'fuckingbitch',
	'fuckinn',
	'fuckinnut',
	'fuckinnuts',
	'fuckinrigh',
	'fuckinright',
	'fuckinuts',
	'fuckit',
	'fuckitt',
	'fuckk',
	'fuckka',
	'fuckkad',
	'fuckkar',
	'fuckkba',
	'fuckkck',
	'fuckke',
	'fuckked',
	'fuckken',
	'fuckker',
	'fuckket',
	'fuckkhe',
	'fuckki',
	'fuckkin',
	'fuckkit',
	'fuckkk',
	'fuckkkk',
	'fuckkkkk',
	'fuckkkkkk',
	'fuckkma',
	'fuckkme',
	'fuckkno',
	'fuckknob',
	'fuckknub',
	'fuckkof',
	'fuckkpi',
	'fuckks',
	'fuckkyo',
	'fuckma',
	'fuckmaa',
	'fuckmahard',
	'fuckme',
	'fuckmee',
	'fuckmehar',
	'fuckmehard',
	'fuckmeherd',
	'fuckmma',
	'fuckmme',
	'fuckmonkay',
	'fuckmonke',
	'fuckmonkey',
	'fuckmunkey',
	'fucknob',
	'fuckof',
	'fuckoff',
	'fuckoof',
	'fuckpeg',
	'fuckpi',
	'fuckpig',
	'fuckpii',
	'fuckppi',
	'fucks',
	'fuckss',
	'fucktar',
	'fucktard',
	'fuckterd',
	'fuckuff',
	'fuckwhor',
	'fuckwhora',
	'fuckwhore',
	'fuckwhure',
	'fuckyo',
	'fuckyoo',
	'fuckyou',
	'fuckyuu',
	'fuckyyo',
	'fudgepacker',
	'fuffuck',
	'fufucck',
	'fufuck',
	'fufuckk',
	'fufufuck',
	'fufufufuck',
	'fufufufufuck',
	'fufuuck',
	'fuggly',
	'fuglly',
	'fugly',
	'fuglyy',
	'fuk',
	'fukk',
	'fukks',
	'fuks',
	'fukss',
	'funeral',
	'funfuck',
	'fungus',
	'fuubar',
	'fuuc',
	'fuucck',
	'fuuck',
	'fuucka',
	'fuuckad',
	'fuuckar',
	'fuuckba',
	'fuuckck',
	'fuucke',
	'fuucked',
	'fuucken',
	'fuucker',
	'fuucket',
	'fuuckhe',
	'fuucki',
	'fuuckin',
	'fuuckit',
	'fuuckk',
	'fuuckkk',
	'fuuckma',
	'fuuckme',
	'fuuckof',
	'fuuckpi',
	'fuucks',
	'fuuckyo',
	'fuufuck',
	'fuugly',
	'fuuk',
	'fuuks',
	'fuutfuck',
	'fuutfucker',
	'fuuuck',
	'gaaysex',
	'gangbang',
	'gangbanged',
	'gangbanger',
	'gangsta',
	'gatorbait',
	'gaymothafockinwhore',
	'gaymuthafuckenwhore',
	'gaymuthafuckinwhor',
	'gaymuthafuckinwhora',
	'gaymuthafuckinwhore',
	'gaymuthafuckinwhure',
	'gayseex',
	'gaysex',
	'gaysexx',
	'gayssex',
	'gayysex',
	'geeez',
	'geeni',
	'geez',
	'geezer',
	'geezz',
	'geni',
	'genii',
	'genital',
	'genni',
	'getiton',
	'geymuthefuckinwhore',
	'ggaysex',
	'ggeez',
	'ggeni',
	'gggook',
	'gginzo',
	'ggipp',
	'ggob',
	'ggod',
	'ggook',
	'ggookk',
	'ggoook',
	'ggoy',
	'ggoyim',
	'ggroe',
	'ggubba',
	'ggummer',
	'ggyp',
	'ggypo',
	'ggypp',
	'ggyppie',
	'ggyppo',
	'ggyppy',
	'giinzo',
	'giipp',
	'ginnzo',
	'ginzo',
	'ginzoo',
	'ginzzo',
	'gipp',
	'gippp',
	'girls',
	'givehead',
	'glazeddonut',
	'gob',
	'gobb',
	'god',
	'godammit',
	'godamnmuthafucker',
	'godd',
	'goddamit',
	'goddammit',
	'goddamn',
	'goddamned',
	'goddamnes',
	'goddamnit',
	'goddamnmuthafuckar',
	'goddamnmuthafucke',
	'goddamnmuthafucker',
	'goddemnmuthefucker',
	'goldenshower',
	'gonorrehea',
	'gonzagas',
	'goob',
	'gook',
	'gookk',
	'gookkk',
	'goook',
	'goookk',
	'gooook',
	'gooy',
	'gooyim',
	'gotohell',
	'goy',
	'goyiim',
	'goyim',
	'goyimm',
	'goyy',
	'goyyim',
	'greaseball',
	'gringo',
	'groe',
	'groee',
	'grooe',
	'grostulation',
	'grroe',
	'gubba',
	'gubbaa',
	'gubbba',
	'guddamnmuthafucker',
	'gummeer',
	'gummer',
	'gummerr',
	'gummmer',
	'gun',
	'guubba',
	'guummer',
	'gyp',
	'gypo',
	'gypoo',
	'gypp',
	'gyppie',
	'gyppiee',
	'gyppiie',
	'gyppo',
	'gyppoo',
	'gyppp',
	'gypppie',
	'gypppo',
	'gypppy',
	'gyppy',
	'gyppyy',
	'gyyp',
	'gyypo',
	'gyypp',
	'gyyppie',
	'gyyppo',
	'gyyppy',
	'haadfuck',
	'haapa',
	'haardon',
	'haarem',
	'hamas',
	'handjob',
	'hapa',
	'hapaa',
	'happa',
	'harddon',
	'hardon',
	'hardonn',
	'hardoon',
	'hareem',
	'harem',
	'haremm',
	'harrdon',
	'harrem',
	'headfuck',
	'headlights',
	'hebbe',
	'hebe',
	'hebee',
	'heeb',
	'heebb',
	'heebe',
	'heedfuck',
	'heeeb',
	'heell',
	'heerpes',
	'hell',
	'helll',
	'henhouse',
	'heroin',
	'herpees',
	'herpes',
	'herpess',
	'herppes',
	'herrpes',
	'heterosexual',
	'hhapa',
	'hhardon',
	'hharem',
	'hhebe',
	'hheeb',
	'hhell',
	'hherpes',
	'hhiv',
	'hhobo',
	'hhodgie',
	'hhoes',
	'hhole',
	'hhomo',
	'hhonger',
	'hhonk',
	'hhonkey',
	'hhonky',
	'hhore',
	'hhork',
	'hhorney',
	'hhorny',
	'hhummer',
	'hhusky',
	'hhussy',
	'hhymen',
	'hhymie',
	'hiiv',
	'hijack',
	'hijacker',
	'hijacking',
	'hillbillies',
	'hindoo',
	'hiscock',
	'hiskeydick',
	'hiskydick',
	'hitdick',
	'hitenigger',
	'hitfuck',
	'hitfucker',
	'hitler',
	'hitlerism',
	'hitlerist',
	'hiv',
	'hivv',
	'ho',
	'hobbo',
	'hobo',
	'hoboo',
	'hoddgie',
	'hodggie',
	'hodgie',
	'hodgiee',
	'hodgiie',
	'hoees',
	'hoes',
	'hoess',
	'hole',
	'holee',
	'holestuffer',
	'homicide',
	'hommo',
	'homo',
	'homobangers',
	'homoo',
	'homosexual',
	'hongeer',
	'honger',
	'hongerr',
	'hongger',
	'honk',
	'honkeey',
	'honkers',
	'honkey',
	'honkeyy',
	'honkk',
	'honkkey',
	'honkky',
	'honky',
	'honkyy',
	'honnger',
	'honnk',
	'honnkey',
	'honnky',
	'hoobo',
	'hoodgie',
	'hooes',
	'hookers',
	'hoole',
	'hoomo',
	'hoonger',
	'hoonk',
	'hoonkey',
	'hoonky',
	'hoore',
	'hoork',
	'hoorney',
	'hoorny',
	'hooters',
	'hore',
	'horee',
	'horefucker',
	'hork',
	'horkk',
	'horneey',
	'horney',
	'horneyy',
	'horniest',
	'hornney',
	'hornny',
	'horny',
	'hornyy',
	'horre',
	'horrk',
	'horrney',
	'horrny',
	'horsashit',
	'horseshit',
	'hortfuck',
	'hosejob',
	'hostage',
	'hotdamn',
	'hotpussy',
	'hottotrot',
	'hummeer',
	'hummer',
	'hummerr',
	'hummmer',
	'hurseshit',
	'huskky',
	'husky',
	'huskyy',
	'hussky',
	'husssy',
	'hussy',
	'hussyy',
	'hustler',
	'hutpussy',
	'huummer',
	'huusky',
	'huussy',
	'hymeen',
	'hymen',
	'hymenn',
	'hymie',
	'hymiee',
	'hymiie',
	'hymmen',
	'hymmie',
	'hyymen',
	'hyymie',
	'ibblowu',
	'ibllowu',
	'ibloowu',
	'iblowu',
	'iblowuu',
	'iblowwu',
	'idiot',
	'igaass',
	'igass',
	'igasss',
	'igbastard',
	'iggass',
	'iiblowu',
	'iigass',
	'iikey',
	'iincest',
	'iindick',
	'iinsest',
	'iipshit',
	'iissass',
	'iitch',
	'iitfuck',
	'ikeey',
	'ikey',
	'ikeyy',
	'ikkey',
	'illegal',
	'imbernigger',
	'impdick',
	'inccest',
	'inceest',
	'incesst',
	'incest',
	'incestt',
	'inddick',
	'indicck',
	'indick',
	'indickk',
	'indiick',
	'ingerfuck',
	'ingerfucked',
	'ingerfucker',
	'ingerfuckers',
	'ingerfucking',
	'inncest',
	'inndick',
	'innsest',
	'inseest',
	'insesst',
	'insest',
	'insestt',
	'inssest',
	'intercourse',
	'interracial',
	'inthaass',
	'intheass',
	'inthebuff',
	'ippshit',
	'ipshhit',
	'ipshiit',
	'ipshit',
	'ipshitt',
	'ipsshit',
	`israel's`,
	'israeli',
	'issaass',
	'issass',
	'issasss',
	'isssass',
	'istfuck',
	'istfucked',
	'istfucker',
	'istfucking',
	'italiano',
	'itcch',
	'itch',
	'itchh',
	'itffuck',
	'itfucck',
	'itfuck',
	'itfucker',
	'itfuckin',
	'itfuckk',
	'itfuuck',
	'ittch',
	'ittfuck',
	'jaap',
	'jackass',
	'jackoff',
	'jackshit',
	'jacktheripper',
	'jap',
	'japanese',
	'japcrap',
	'jebbus',
	'jebus',
	'jebuss',
	'jebuus',
	'jeckshit',
	'jeebus',
	'jeeez',
	'jeew',
	'jeez',
	'jeezz',
	'jerkoff',
	'jesuschrist',
	'jew',
	'jewish',
	'jeww',
	'jiga',
	'jigaa',
	'jigaboo',
	'jigg',
	'jigga',
	'jiggaa',
	'jiggabo',
	'jiggeer',
	'jigger',
	'jiggerr',
	'jiggg',
	'jiggga',
	'jiggger',
	'jigggy',
	'jiggy',
	'jiggyy',
	'jihad',
	'jiiga',
	'jiigg',
	'jiigga',
	'jiigger',
	'jiiggy',
	'jiism',
	'jiiz',
	'jiizim',
	'jiizm',
	'jiizz',
	'jiizzim',
	'jiizzum',
	'jijjiboo',
	'jimfish',
	'jism',
	'jismm',
	'jissm',
	'jiz',
	'jiziim',
	'jizim',
	'jizimm',
	'jizjuice',
	'jizm',
	'jizmm',
	'jizz',
	'jizziim',
	'jizzim',
	'jizzimm',
	'jizzm',
	'jizzum',
	'jizzumm',
	'jizzuum',
	'jizzz',
	'jizzzim',
	'jizzzum',
	'jjap',
	'jjebus',
	'jjeez',
	'jjew',
	'jjiga',
	'jjigg',
	'jjigga',
	'jjigger',
	'jjiggy',
	'jjism',
	'jjiz',
	'jjizim',
	'jjizm',
	'jjizz',
	'jjizzim',
	'jjizzum',
	'jjugs',
	'joint',
	'juggalo',
	'juggs',
	'jugs',
	'jugss',
	'junglebunny',
	'juugs',
	'kaaffer',
	'kaaffir',
	'kaaffre',
	'kaafir',
	'kaanake',
	'kaffeer',
	'kaffer',
	'kafferr',
	'kafffer',
	'kafffir',
	'kafffre',
	'kaffiir',
	'kaffir',
	'kaffirr',
	'kaffre',
	'kaffree',
	'kaffrre',
	'kafiir',
	'kafir',
	'kafirr',
	'kanaake',
	'kanake',
	'kanakee',
	'kanakke',
	'kankbitch',
	'kankfuck',
	'kankwhore',
	'kankybitch',
	'kankywhore',
	'kannake',
	'kessass',
	'kid',
	'kiggeer',
	'kigger',
	'kiggerr',
	'kiggger',
	'kiid',
	'kiigger',
	'kiiike',
	'kiike',
	'kiikee',
	'kiikke',
	'kiink',
	'kiinky',
	'kike',
	'kikee',
	'kikeee',
	'kikke',
	'kikkee',
	'kikkke',
	'kill',
	'killed',
	'killer',
	'killing',
	'kills',
	'kink',
	'kinkk',
	'kinkky',
	'kinky',
	'kinkyy',
	'kinnk',
	'kinnky',
	'kissass',
	'kkaffer',
	'kkaffir',
	'kkaffre',
	'kkafir',
	'kkanake',
	'kkid',
	'kkigger',
	'kkiike',
	'kkike',
	'kkikee',
	'kkikke',
	'kkink',
	'kkinky',
	'kkk',
	'kkkike',
	'kkkk',
	'kkock',
	'kkondum',
	'kkotex',
	'kkrap',
	'kkrappy',
	'kkum',
	'kkummer',
	'kkums',
	'kkunt',
	'kkyke',
	'knife',
	'knockers',
	'kocck',
	'kock',
	'kockk',
	'konddum',
	'kondum',
	'kondumm',
	'konduum',
	'konndum',
	'koock',
	'koondum',
	'kootex',
	'koteex',
	'kotex',
	'kotexx',
	'kottex',
	'kraap',
	'kraappy',
	'krap',
	'krapp',
	'krapppy',
	'krappy',
	'krappyy',
	'kraut',
	'krrap',
	'krrappy',
	'kum',
	'kumbubble',
	'kumbullbe',
	'kumm',
	'kummeer',
	'kummer',
	'kummerr',
	'kumming',
	'kummmer',
	'kumms',
	'kumquat',
	'kums',
	'kumss',
	'kunilingus',
	'kunnilingus',
	'kunnt',
	'kunt',
	'kuntt',
	'kuum',
	'kuummer',
	'kuums',
	'kuunt',
	'kyke',
	'kykee',
	'kykke',
	'kyyke',
	'laaid',
	'lactate',
	'laid',
	'laidd',
	'laiid',
	'lapdance',
	'latin',
	'leesbin',
	'leesbo',
	'leez',
	'leezbe',
	'leezbo',
	'leezz',
	'leezzo',
	'lesbain',
	'lesbayn',
	'lesbbin',
	'lesbbo',
	'lesbian',
	'lesbiin',
	'lesbin',
	'lesbinn',
	'lesbo',
	'lesboo',
	'lessbin',
	'lessbo',
	'lez',
	'lezbbe',
	'lezbbo',
	'lezbe',
	'lezbee',
	'lezbefriends',
	'lezbo',
	'lezboo',
	'lezz',
	'lezzbe',
	'lezzbo',
	'lezzo',
	'lezzoo',
	'lezzz',
	'lezzzo',
	'libbido',
	'liberal',
	'libiddo',
	'libido',
	'libidoo',
	'libiido',
	'liccker',
	'licckme',
	'lickeer',
	'licker',
	'lickerr',
	'lickker',
	'lickkme',
	'lickme',
	'lickmee',
	'lickmme',
	'liibido',
	'liicker',
	'liickme',
	'limpdick',
	'lingerie',
	'liquor',
	'livesex',
	'llaid',
	'llesbin',
	'llesbo',
	'llez',
	'llezbe',
	'llezbo',
	'llezz',
	'llezzo',
	'llibido',
	'llicker',
	'llickme',
	'loadedgun',
	'looser',
	'loser',
	'lotion',
	'lovebone',
	'lovegoo',
	'lovegun',
	'lovejuice',
	'lovemuscle',
	'lovepistol',
	'loverocket',
	'lowlife',
	'lsd',
	'lubejob',
	'lucifer',
	'luckycammeltoe',
	'maacaca',
	'maafia',
	'maams',
	'macaaca',
	'macaca',
	'macacaa',
	'macacca',
	'maccaca',
	'maffia',
	'mafia',
	'mafiaa',
	'mafiia',
	'magicwand',
	'mamms',
	'mams',
	'mamss',
	'manhater',
	'manpaste',
	'marijuana',
	'mastabate',
	'mastabater',
	'masterbate',
	'masterblaster',
	'mastrabator',
	'masturbate',
	'masturbating',
	'mattrassprincass',
	'mattressprincess',
	'meatbeatter',
	'meatrack',
	'meth',
	'mexican',
	'mggeer',
	'mgger',
	'mggerr',
	'mggger',
	'mgggor',
	'mggoor',
	'mggor',
	'mggorr',
	'mickeyfinn',
	'mideast',
	'miilf',
	'milf',
	'milff',
	'millf',
	'minority',
	'mmacaca',
	'mmafia',
	'mmams',
	'mmgger',
	'mmggor',
	'mmilf',
	'mmockey',
	'mmockie',
	'mmocky',
	'mmofo',
	'mmoky',
	'mmoles',
	'mmolest',
	'mmuff',
	'mocckey',
	'mocckie',
	'moccky',
	'mockeey',
	'mockey',
	'mockeyy',
	'mockie',
	'mockiee',
	'mockiie',
	'mockkey',
	'mockkie',
	'mockky',
	'mocky',
	'mockyy',
	'moffo',
	'mofo',
	'mofoo',
	'mokky',
	'moky',
	'mokyy',
	'molees',
	'moleest',
	'moles',
	'moless',
	'molesst',
	'molest',
	'molestation',
	'molester',
	'molestor',
	'molestt',
	'molles',
	'mollest',
	'moneyshot',
	'moockey',
	'moockie',
	'moocky',
	'moofo',
	'mooky',
	'mooles',
	'moolest',
	'mooncricket',
	'mormon',
	'moron',
	'moslem',
	'mosshead',
	'mothafuck',
	'mothafucka',
	'mothafuckad',
	'mothafuckar',
	'mothafuckaz',
	'mothafucke',
	'mothafucked',
	'mothafucken',
	'mothafuckeng',
	'mothafuckengs',
	'mothafucker',
	'mothafucki',
	'mothafuckin',
	'mothafucking',
	'mothafuckings',
	'motharfuck',
	'motharfuckad',
	'motharfuckar',
	'motharfuckin',
	'motharfucking',
	'motharfuckings',
	'mothefuck',
	'mothefucke',
	'mothefucked',
	'mothefucker',
	'mothefuckez',
	'mothefuckin',
	'mothefucking',
	'mothefuckings',
	'motherfuck',
	'motherfucke',
	'motherfucked',
	'motherfucken',
	'motherfuckeng',
	'motherfuckengs',
	'motherfucker',
	'motherfucki',
	'motherfuckin',
	'motherfucking',
	'motherfuckings',
	'motherlovebone',
	'muff',
	'muffdive',
	'muffdiver',
	'mufff',
	'muffindiver',
	'mufflikcer',
	'murder',
	'murderer',
	'muslim',
	'muthafuck',
	'muthafucka',
	'muthafuckaz',
	'muthafucked',
	'muthafucker',
	'muthafuckin',
	'muthafucking',
	'muthafuckings',
	'mutherfuck',
	'mutherfucked',
	'mutherfucker',
	'mutherfuckin',
	'mutherfucking',
	'mutherfuckings',
	'muuff',
	'naaked',
	'naazi',
	'naked',
	'nakedd',
	'nakeed',
	'nakked',
	'narcotic',
	'nasty',
	'nastybitch',
	'nastyho',
	'nastyslut',
	'nastywhore',
	'nazi',
	'nazii',
	'nazzi',
	'neccro',
	'necro',
	'necroo',
	'necrro',
	'neecro',
	'neegro',
	'neggro',
	'negro',
	`negro's`,
	'negroes',
	'negroid',
	'negroo',
	'negrro',
	'nestybitch',
	'nestyslut',
	'nestywhore',
	'nfuckable',
	'nig',
	'nigeer',
	'niger',
	'nigerian',
	'nigerians',
	'nigerr',
	'nigg',
	'nigga',
	'niggaa',
	'niggaah',
	'niggaar',
	'niggaaz',
	'niggaga',
	'niggagaga',
	'niggagagaga',
	'niggah',
	'niggahh',
	'niggar',
	`niggar's`,
	'niggaracc',
	'niggaracci',
	'niggard',
	`niggard'`,
	`niggard's`,
	'niggardad',
	'niggarde',
	'niggarded',
	'niggardin',
	'niggarding',
	'niggardl',
	'niggardlinass',
	`niggardlinass's`,
	'niggardlines',
	'niggardliness',
	`niggardliness'`,
	`niggardliness's`,
	'niggardly',
	'niggards',
	'niggarhaad',
	'niggarhola',
	'niggarr',
	'niggars',
	'niggaz',
	'niggazz',
	'nigge',
	'niggee',
	'niggeeh',
	'niggeer',
	'niggeez',
	'niggegegeger',
	'niggegeger',
	'niggeger',
	'niggeh',
	'niggehh',
	'nigger',
	`nigger'`,
	`nigger's`,
	'niggerd',
	`niggerd's`,
	'niggerded',
	'niggerding',
	'niggerdliness',
	`niggerdliness's`,
	'niggerdly',
	'niggerds',
	'niggerecci',
	'niggered',
	'niggerer',
	'niggererer',
	'niggerererer',
	'niggerhea',
	'niggerhead',
	'niggerheed',
	'niggerhol',
	'niggerhole',
	'niggerhule',
	'niggering',
	'niggerr',
	'niggerrr',
	'niggerrrr',
	'niggerrrrr',
	'niggers',
	'niggez',
	'niggezz',
	'niggg',
	'niggga',
	'nigggaa',
	'nigggah',
	'nigggar',
	'nigggaz',
	'niggge',
	'nigggeh',
	'niggger',
	'nigggez',
	'nigggga',
	'nigggger',
	'niggggga',
	'niggggger',
	'nigggggga',
	'nigggggger',
	'nigggggggga',
	'nigggggggger',
	'nigggl',
	'nigggla',
	'nigggle',
	'nigggo',
	'nigggor',
	'nigggu',
	'nigggur',
	'niggl',
	'niggla',
	'nigglaa',
	'nigglad',
	'nigglas',
	'niggle',
	'niggled',
	'nigglee',
	'niggles',
	'nigglet',
	'nigglin',
	'niggling',
	'nigglings',
	'niggll',
	'nigglla',
	'nigglle',
	'niggnog',
	'niggo',
	'niggoo',
	'niggoor',
	'niggor',
	'niggorr',
	'niggr',
	'niggra',
	'niggre',
	'niggu',
	'niggur',
	'niggurr',
	'nigguu',
	'nigguur',
	'nigleet',
	'niglet',
	'niglett',
	'nigllet',
	'nignnog',
	'nignog',
	'nignogg',
	'nignoog',
	'nigr',
	'nigra',
	'nigraa',
	'nigre',
	'nigree',
	'nigrr',
	'nigrra',
	'nigrre',
	'niig',
	'niiger',
	'niigg',
	'niigga',
	'niiggah',
	'niiggar',
	'niiggaz',
	'niigge',
	'niiggeh',
	'niigger',
	'niiggez',
	'niiggga',
	'niiggl',
	'niiggla',
	'niiggle',
	'niiggo',
	'niiggor',
	'niiggu',
	'niiggur',
	'niiglet',
	'niignog',
	'niigr',
	'niigra',
	'niigre',
	'niip',
	'niipple',
	'niittit',
	'ninigga',
	'ninigger',
	'nininigga',
	'nininigger',
	'ninininigga',
	'ninininigger',
	'nip',
	'nipp',
	'nipple',
	'nipplee',
	'nipplering',
	'nipplle',
	'nippple',
	'nittiit',
	'nittit',
	'nittitt',
	'nitttit',
	'nlggeer',
	'nlgger',
	'nlggerr',
	'nlggger',
	'nlgggor',
	'nlggoor',
	'nlggor',
	'nlggorr',
	'nllgger',
	'nllggor',
	'nnaked',
	'nnazi',
	'nnecro',
	'nnegro',
	'nnig',
	'nniger',
	'nnigg',
	'nnigga',
	'nniggaa',
	'nniggah',
	'nniggar',
	'nniggaz',
	'nnigge',
	'nniggeh',
	'nnigger',
	'nniggez',
	'nniggga',
	'nniggl',
	'nniggla',
	'nniggle',
	'nniggo',
	'nniggor',
	'nniggu',
	'nniggur',
	'nniglet',
	'nnignog',
	'nnigr',
	'nnigra',
	'nnigre',
	'nniigga',
	'nnip',
	'nnipple',
	'nnittit',
	'nnlgger',
	'nnlggor',
	'nnnigga',
	'nnnigger',
	'nnnnigga',
	'nnnnigger',
	'nnnnnigga',
	'nnnnnigger',
	'nnook',
	'nnookey',
	'nnookie',
	'nnoonan',
	'nnooner',
	'nnude',
	'nnudger',
	'nnuke',
	'nnymph',
	'nofuckengway',
	'nofuckingwa',
	'nofuckingway',
	'nofuckingwey',
	'nook',
	'nookeey',
	'nookey',
	'nookeyy',
	'nookie',
	'nookiee',
	'nookiie',
	'nookk',
	'nookkey',
	'nookkie',
	'noonaan',
	'noonan',
	'nooneer',
	'nooner',
	'noonerr',
	'noonnan',
	'noonner',
	'noook',
	'noookey',
	'noookie',
	'nooonan',
	'noooner',
	'nownigger',
	'ntheass',
	'nudde',
	'nuddger',
	'nude',
	'nudee',
	'nudgeer',
	'nudger',
	'nudgerr',
	'nudgger',
	'nufuckingway',
	'nuke',
	'nukee',
	'nukke',
	'nutfuckar',
	'nutfucke',
	'nutfucker',
	'nuude',
	'nuudger',
	'nuuke',
	'nymmph',
	'nymph',
	'nymphh',
	'nympph',
	'nyymph',
	'oddamnmuthafucker',
	'ofuckingway',
	'onofabitch',
	'onofbitch',
	'ontherag',
	'ooral',
	'oorga',
	'oorgasm',
	'oorgies',
	'oorgy',
	'ootfuck',
	'ootfucker',
	'optheass',
	'oraal',
	'oral',
	'orall',
	'orga',
	'orgaa',
	'orgaasm',
	'orgasim',
	'orgasm',
	'orgasmm',
	'orgassm',
	'orgga',
	'orggasm',
	'orggies',
	'orggy',
	'orgiees',
	'orgies',
	'orgiess',
	'orgiies',
	'orgy',
	'orgyy',
	'orral',
	'orrga',
	'orrgasm',
	'orrgies',
	'orrgy',
	'orseshit',
	'osama',
	'othafuck',
	'othafucka',
	'othafuckaz',
	'othafucked',
	'othafucker',
	'othafuckin',
	'othafucking',
	'othafuckings',
	'otherfuck',
	'otherfucked',
	'otherfucker',
	'otherfuckin',
	'otherfucking',
	'otherfuckings',
	'otpussy',
	'paaki',
	'paansy',
	'paanti',
	'paayo',
	'paghettinigger',
	'paki',
	'pakii',
	'pakki',
	'palesimian',
	'palestinian',
	'pannsy',
	'pannti',
	'pansies',
	'panssy',
	'pansy',
	'pansyy',
	'panti',
	'panties',
	'pantii',
	'pantti',
	'payo',
	'payoo',
	'payyo',
	'pearlnecklace',
	'peccker',
	'peckeer',
	'pecker',
	'peckerr',
	'peckerwood',
	'peckker',
	'pee',
	'pee-pee',
	'peecker',
	'peee',
	'peehole',
	'peendy',
	'peenile',
	'peenis',
	'peepshow',
	'peepshpw',
	'peerv',
	'penddy',
	'pendy',
	'pendyy',
	'penetration',
	'peni5',
	'peniile',
	'peniis',
	'penile',
	'penilee',
	'penille',
	'penis',
	'penises',
	'peniss',
	'penndy',
	'pennile',
	'pennis',
	'penthouse',
	'period',
	'perrv',
	'perv',
	'pervv',
	'phhuk',
	'phhuked',
	'phhuq',
	'phonesex',
	'phuk',
	'phuked',
	'phukedd',
	'phukeed',
	'phuking',
	'phukk',
	'phukked',
	'phukking',
	'phungky',
	'phuq',
	'phuqq',
	'phuuk',
	'phuuked',
	'phuuq',
	'pi55',
	'picaninny',
	'piccaninny',
	'pickaninny',
	'piiker',
	'piikey',
	'piiky',
	'piimp',
	'piimped',
	'piimper',
	'piiss',
	'piissed',
	'piisser',
	'piisses',
	'piissin',
	'piistol',
	'piixie',
	'piixy',
	'pikeer',
	'pikeey',
	'piker',
	'pikerr',
	'pikey',
	'pikeyy',
	'pikker',
	'pikkey',
	'pikky',
	'piky',
	'pikyy',
	'pimmp',
	'pimmped',
	'pimmper',
	'pimp',
	'pimped',
	'pimpedd',
	'pimpeed',
	'pimpeer',
	'pimper',
	'pimperr',
	'pimpjuic',
	'pimpjuice',
	'pimpp',
	'pimpped',
	'pimpper',
	'pimpsimp',
	'pindick',
	'piss',
	'pissed',
	'pissedd',
	'pisseed',
	'pisseer',
	'pissees',
	'pisser',
	'pisserr',
	'pisses',
	'pissess',
	'pisshead',
	'pissiin',
	'pissin',
	'pissing',
	'pissinn',
	'pissoff',
	'pisss',
	'pisssed',
	'pissser',
	'pissses',
	'pisssin',
	'pisstol',
	'pistol',
	'pistoll',
	'pistool',
	'pisttol',
	'pixie',
	'pixiee',
	'pixiie',
	'pixxie',
	'pixxy',
	'pixy',
	'pixyy',
	'playboy',
	'playgirl',
	'poccha',
	'poccho',
	'pocha',
	'pochaa',
	'pochha',
	'pochho',
	'pocho',
	'pochoo',
	'pocketpool',
	'pohhm',
	'pohm',
	'pohmm',
	'polaack',
	'polacck',
	'polack',
	'polackk',
	'pom',
	'pomm',
	'pommie',
	'pommiee',
	'pommiie',
	'pommmie',
	'poo',
	'poocha',
	'poocho',
	'poohm',
	'poolack',
	'poom',
	'poommie',
	'poon',
	'poonn',
	'poontang',
	'pooo',
	'pooon',
	'pooop',
	'poooper',
	'poop',
	'poopeer',
	'pooper',
	'pooperr',
	'pooperscooper',
	'poopimp',
	'pooping',
	'poopp',
	'poopper',
	'poorn',
	'poorno',
	'poorwhitetrash',
	'popiimp',
	'popimmp',
	'popimp',
	'popimpp',
	'poppimp',
	'porchmonkey',
	'porn',
	'pornflick',
	'pornking',
	'pornn',
	'pornno',
	'porno',
	'pornography',
	'pornoo',
	'pornprincass',
	'pornprincess',
	'porrn',
	'porrno',
	'pot',
	'poverty',
	'ppaki',
	'ppansy',
	'ppanti',
	'ppayo',
	'ppecker',
	'ppee',
	'ppendy',
	'ppenile',
	'ppenis',
	'pperv',
	'pphuk',
	'pphuked',
	'pphuq',
	'ppiker',
	'ppikey',
	'ppiky',
	'ppimp',
	'ppimped',
	'ppimper',
	'ppiss',
	'ppissed',
	'ppisser',
	'ppisses',
	'ppissin',
	'ppistol',
	'ppixie',
	'ppixy',
	'ppocha',
	'ppocho',
	'ppohm',
	'ppolack',
	'ppom',
	'ppommie',
	'ppoo',
	'ppoon',
	'ppoop',
	'ppooper',
	'ppopimp',
	'pporn',
	'pporno',
	'ppppppussy',
	'pppppussy',
	'ppppussy',
	'ppprick',
	'pppussy',
	'ppric',
	'ppricck',
	'pprick',
	'pprickk',
	'ppriick',
	'ppros',
	'pprrick',
	'ppube',
	'ppubic',
	'ppud',
	'ppudboy',
	'ppudd',
	'ppuke',
	'ppuss',
	'ppussie',
	'ppusssy',
	'ppussy',
	'ppussyy',
	'ppusy',
	'ppuussy',
	'premature',
	'pric',
	'pricc',
	'priccck',
	'pricck',
	'pricckk',
	'prick',
	'prickhead',
	'prickk',
	'prickkk',
	'priic',
	'priicck',
	'priick',
	'priickk',
	'priiick',
	'primetime',
	'proos',
	'propaganda',
	'pros',
	'pross',
	'prostitute',
	'protestant',
	'prric',
	'prricck',
	'prrick',
	'prrickk',
	'prriick',
	'prros',
	'prrrick',
	'ptheass',
	'pu55i',
	'pu55y',
	'pubbe',
	'pubbic',
	'pube',
	'pubee',
	'pubic',
	'pubicc',
	'pubiclice',
	'pubiic',
	'pud',
	'pudbboy',
	'pudbooy',
	'pudboy',
	'pudboyy',
	'pudd',
	'puddboy',
	'puddd',
	'puke',
	'pukee',
	'pukke',
	'puntang',
	'pupupupupussy',
	'pupupupussy',
	'pupupussy',
	'pupussy',
	'purinapricnass',
	'purinapricness',
	'puss',
	'pussie',
	'pussiee',
	'pussies',
	'pussiie',
	'pusss',
	'pusssie',
	'pusssy',
	'pusssyy',
	'pussy',
	'pussyaatar',
	'pussyca',
	'pussycat',
	'pussycet',
	'pussyeate',
	'pussyeater',
	'pussyeeter',
	'pussyfuckar',
	'pussyfucke',
	'pussyfucker',
	'pussylecker',
	'pussyleps',
	'pussylickar',
	'pussylicke',
	'pussylicker',
	'pussylip',
	'pussylips',
	'pussylovar',
	'pussylove',
	'pussylover',
	'pussyluver',
	'pussypoundar',
	'pussypounde',
	'pussypounder',
	'pussypuunder',
	'pussysy',
	'pussysysy',
	'pussysysysy',
	'pussysysysysy',
	'pussyy',
	'pussyyy',
	'pussyyyy',
	'pussyyyyy',
	'pussyyyyyy',
	'pusy',
	'pusyfucker',
	'pusyy',
	'puube',
	'puubic',
	'puud',
	'puudboy',
	'puudd',
	'puuke',
	'puuss',
	'puussie',
	'puussy',
	'puussyy',
	'puusy',
	'qqueef',
	'qqueer',
	'qquim',
	'quashie',
	'queeef',
	'queeer',
	'queef',
	'queeff',
	'queer',
	'queerr',
	'quickie',
	'quiim',
	'quim',
	'quimm',
	'quueef',
	'quueer',
	'quuim',
	'ra8s',
	'raabbi',
	'raape',
	'raaped',
	'raaper',
	'raapist',
	'rabbbi',
	'rabbi',
	'rabbii',
	'racial',
	'racist',
	'rack-whore',
	'rackwhore',
	'radical',
	'radicals',
	'raghead',
	'rantafuck',
	'rape',
	'raped',
	'rapedd',
	'rapee',
	'rapeed',
	'rapeer',
	'raper',
	'raperr',
	'rapiist',
	'rapisst',
	'rapist',
	'rapistt',
	'rapped',
	'rapper',
	'rappist',
	'reakfuck',
	'reakyfucker',
	'rearend',
	'rearentry',
	'rectum',
	'redlight',
	'redneck',
	'reefer',
	'reefuck',
	'reere',
	'reestie',
	'reetard',
	'refugee',
	'reject',
	'remains',
	'rentafuck',
	'rentefuck',
	'republican',
	'rere',
	'reree',
	'rerre',
	'retaard',
	'retard',
	'retardd',
	'retarded',
	'retarrd',
	'rettard',
	'ribbbed',
	'ribbed',
	'ribbedd',
	'ribbeed',
	'riggeer',
	'rigger',
	'riggerr',
	'riggger',
	'riibbed',
	'riigger',
	'riimjob',
	'rimjjob',
	'rimjob',
	'rimjobb',
	'rimjoob',
	'rimming',
	'rimmjob',
	'ripdick',
	'robber',
	'roundeye',
	'rrabbi',
	'rrape',
	'rraped',
	'rraper',
	'rrapist',
	'rrere',
	'rretard',
	'rribbed',
	'rrigger',
	'rrimjob',
	'rrump',
	'rummp',
	'rump',
	'rumpp',
	'russki',
	'russkie',
	'ruump',
	'saadis',
	'saadom',
	'saandm',
	'saatan',
	'saddis',
	'saddom',
	'sadiis',
	'sadis',
	'sadiss',
	'sadom',
	'sadomm',
	'sadoom',
	'samckdaddy',
	'sanddm',
	'sandm',
	'sandmm',
	'sandniggar',
	'sandnigge',
	'sandnigger',
	'sanndm',
	'sataan',
	'satan',
	'satann',
	'sattan',
	'scaag',
	'scaat',
	'scag',
	'scagg',
	'scallywag',
	'scat',
	'scatt',
	'sccag',
	'sccat',
	'sccrew',
	'sccum',
	'schlong',
	'screew',
	'screw',
	'screww',
	'screwyou',
	'scrotum',
	'scrrew',
	'scum',
	'scumm',
	'scuum',
	'seemen',
	'seeppo',
	'seex',
	'seexed',
	'seexing',
	'seexpot',
	'seextoy',
	'seexual',
	'seexy',
	'semeen',
	'semen',
	'semenn',
	'semmen',
	'sendnigger',
	'seppo',
	'seppoo',
	'sepppo',
	'servant',
	'sex',
	'sexed',
	'sexedd',
	'sexeed',
	'sexfarm',
	'sexhound',
	'sexhouse',
	'sexiing',
	'sexing',
	'sexingg',
	'sexinng',
	'sexkitten',
	'sexpoot',
	'sexpot',
	'sexpott',
	'sexppot',
	'sexslave',
	'sextogo',
	'sextooy',
	'sextoy',
	'sextoys',
	'sextoyy',
	'sexttoy',
	'sexuaal',
	'sexual',
	'sexuall',
	'sexually',
	'sexuual',
	'sexwhore',
	'sexx',
	'sexxed',
	'sexxing',
	'sexxpot',
	'sexxtoy',
	'sexxual',
	'sexxy',
	'sexy',
	'sexy-slim',
	'sexymoma',
	'sexyy',
	'shaag',
	'shaat',
	'shaav',
	'shag',
	'shagg',
	'shaggin',
	'shagging',
	'shat',
	'shatt',
	'shav',
	'shavv',
	'shawtypimp',
	'sheeney',
	'shetfuck',
	'shetfucker',
	'shhag',
	'shhat',
	'shhav',
	'shhhit',
	'shhiit',
	'shhit',
	'shhita',
	'shhitad',
	'shhitca',
	'shhite',
	'shhited',
	'shhiter',
	'shhitfi',
	'shhitin',
	'shhitit',
	'shhitol',
	'shhits',
	'shhitt',
	'shhitte',
	'shhittt',
	'shhitty',
	'shhity',
	'shhoot',
	'shhshit',
	'shiit',
	'shiita',
	'shiitad',
	'shiitca',
	'shiite',
	'shiited',
	'shiiter',
	'shiitfi',
	'shiitin',
	'shiitit',
	'shiitol',
	'shiits',
	'shiitt',
	'shiitte',
	'shiittt',
	'shiitty',
	'shiity',
	'shinola',
	'shit',
	'shita',
	'shitaa',
	'shitaad',
	'shitaatar',
	'shitad',
	'shitadd',
	'shitca',
	'shitcaa',
	'shitcan',
	'shitcca',
	'shitcen',
	'shitdic',
	'shitdick',
	'shite',
	'shiteate',
	'shiteater',
	'shited',
	'shitedd',
	'shitee',
	'shiteed',
	'shiteer',
	'shiteeter',
	'shiter',
	'shiterr',
	'shitfac',
	'shitfaca',
	'shitfacad',
	'shitface',
	'shitfaced',
	'shitfece',
	'shitfeced',
	'shitffi',
	'shitfi',
	'shitfii',
	'shitfit',
	'shitfock',
	'shitfocker',
	'shitfoll',
	'shitforbrain',
	'shitforbrains',
	'shitforbreins',
	'shitfuc',
	'shitfuck',
	'shitfuckar',
	'shitfucke',
	'shitfucker',
	'shitful',
	'shitfull',
	'shitfurbrains',
	'shithaad',
	'shithapans',
	'shithapen',
	'shithapens',
	'shithappans',
	'shithappen',
	'shithappens',
	'shithea',
	'shithead',
	'shitheed',
	'shithepens',
	'shitheppens',
	'shithoose',
	'shithous',
	'shithousa',
	'shithouse',
	'shithuuse',
	'shitiin',
	'shitiit',
	'shitin',
	'shiting',
	'shitinn',
	'shitit',
	'shititit',
	'shitititit',
	'shititititit',
	'shititt',
	'shitlis',
	'shitlist',
	'shitol',
	'shitola',
	'shitole',
	'shitoll',
	'shitool',
	'shitootoflock',
	'shitoutofluc',
	'shitoutofluck',
	'shits',
	'shitss',
	'shitstai',
	'shitstain',
	'shitstein',
	'shitt',
	'shitta',
	'shittad',
	'shittar',
	'shittca',
	'shitte',
	'shitted',
	'shittee',
	'shitter',
	'shittfi',
	'shittin',
	'shitting',
	'shittit',
	'shittol',
	'shitts',
	'shittt',
	'shittte',
	'shitttt',
	'shittttt',
	'shitttttt',
	'shittty',
	'shitty',
	'shittyy',
	'shitula',
	'shituutufluck',
	'shity',
	'shityy',
	'shooot',
	'shoot',
	'shooting',
	'shoott',
	'shortfuck',
	'showtime',
	'shshhit',
	'shshiit',
	'shshit',
	'shshitt',
	'shshshit',
	'shshshshit',
	'shshshshshit',
	'shsshit',
	'shurtfuck',
	'sick',
	'sixsixsix',
	'sixtynine',
	'sixtyniner',
	'skaaank',
	'skaank',
	'skaankk',
	'skaanky',
	'skaannk',
	'skank',
	'skankbitch',
	'skankfuck',
	'skankk',
	'skankkk',
	'skankky',
	'skankwhore',
	'skanky',
	'skankybitch',
	'skankywhore',
	'skankyy',
	'skannk',
	'skannkk',
	'skannky',
	'skannnk',
	'skenkbitch',
	'skenkfuck',
	'skenkwhore',
	'skenkybitch',
	'skenkywhore',
	'skinflute',
	'skkaank',
	'skkank',
	'skkankk',
	'skkanky',
	'skkannk',
	'skkkank',
	'skkum',
	'skum',
	'skumbag',
	'skumm',
	'skuum',
	'slaant',
	'slaav',
	'slaave',
	'slannt',
	'slant',
	'slanteye',
	'slantt',
	'slapper',
	'slav',
	'slave',
	'slavedriver',
	'slavee',
	'slavv',
	'slavve',
	'sleezebag',
	'sleezeball',
	'slideitin',
	'sliime',
	'slime',
	'slimeball',
	'slimebucket',
	'slimee',
	'slimme',
	'sllant',
	'sllav',
	'sllave',
	'sllime',
	'slllut',
	'sllopey',
	'sllopy',
	'slluat',
	'sllut',
	'slluts',
	'sllutt',
	'sllutty',
	'slluty',
	'slluut',
	'sloopey',
	'sloopy',
	'slopeey',
	'slopehead',
	'slopey',
	'slopeyy',
	'sloppey',
	'sloppy',
	'slopy',
	'slopyy',
	'slotwhore',
	'sluaat',
	'sluat',
	'sluatt',
	'slut',
	'sluting',
	'sluts',
	'slutss',
	'slutt',
	'slutteng',
	'sluttin',
	'slutting',
	'slutts',
	'sluttt',
	'sluttty',
	'slutty',
	'sluttyy',
	'slutwaar',
	'slutwea',
	'slutwear',
	'slutweer',
	'slutwhor',
	'slutwhora',
	'slutwhore',
	'slutwhure',
	'sluty',
	'slutyy',
	'sluuat',
	'sluut',
	'sluuts',
	'sluutt',
	'sluutty',
	'sluuty',
	'sluuut',
	'smaack',
	'smacck',
	'smack',
	'smackk',
	'smackthemonkey',
	'smmack',
	'smmut',
	'smut',
	'smutt',
	'smuut',
	'snaatch',
	'snatcch',
	'snatch',
	'snatchh',
	'snatchpatch',
	'snattch',
	'sniggar',
	`sniggar's`,
	'sniggarad',
	'sniggaring',
	'sniggars',
	'snigge',
	'sniggee',
	'snigger',
	`snigger'`,
	`snigger's`,
	'sniggere',
	'sniggered',
	'sniggerin',
	'sniggering',
	'sniggers',
	'sniggge',
	'sniigge',
	'sniper',
	'snnatch',
	'snnigge',
	'snnot',
	'snoot',
	'snot',
	'snott',
	'snowback',
	'snowniggar',
	'snownigge',
	'snownigger',
	'snuwnigger',
	'sob',
	'sobb',
	'sockdick',
	'sockmyass',
	'sockmydick',
	'soddom',
	'soddomy',
	'sodom',
	'sodomise',
	'sodomite',
	'sodomize',
	'sodomm',
	'sodommy',
	'sodomy',
	'sodomyy',
	'sodoom',
	'sodoomy',
	'sonofabitch',
	'sonofbitch',
	'sonofebitch',
	'soob',
	'soodom',
	'soodomy',
	'soooty',
	'soos',
	'sootty',
	'sooty',
	'sootyy',
	'sos',
	'soss',
	'soviet',
	'spaank',
	'spaghattiniggar',
	'spaghettibender',
	'spaghettinigge',
	'spaghettinigger',
	'spank',
	'spankk',
	'spankthemonkey',
	'spannk',
	'speerm',
	'speghettinigger',
	'sperm',
	'spermacide',
	'spermbag',
	'spermhearder',
	'spermherder',
	'spermm',
	'sperrm',
	'spic',
	'spicc',
	'spiccc',
	'spicck',
	'spick',
	'spickk',
	'spig',
	'spigg',
	'spigotty',
	'spiic',
	'spiicc',
	'spiick',
	'spiig',
	'spiiic',
	'spiik',
	'spiit',
	'spik',
	'spikk',
	'spit',
	'spitt',
	'spitter',
	'splittail',
	'spooge',
	'spoogee',
	'spoogge',
	'spoooge',
	'sppank',
	'spperm',
	'sppic',
	'sppicc',
	'sppick',
	'sppig',
	'sppiic',
	'sppik',
	'sppit',
	'sppooge',
	'spppic',
	'sppunk',
	'sppunky',
	'spreadeagle',
	'spunk',
	'spunkk',
	'spunkky',
	'spunky',
	'spunkyy',
	'spunnk',
	'spunnky',
	'spuunk',
	'spuunky',
	'sqquaw',
	'squaaw',
	'squaw',
	'squaww',
	'squuaw',
	'ssadis',
	'ssadom',
	'ssandm',
	'ssassin',
	'ssassinate',
	'ssassination',
	'ssatan',
	'sscag',
	'sscat',
	'sscrew',
	'sscum',
	'ssemen',
	'sseppo',
	'ssex',
	'ssexed',
	'ssexing',
	'ssexpot',
	'ssextoy',
	'ssexual',
	'ssexy',
	'ssffuck',
	'ssfucck',
	'ssfuck',
	'ssfucker',
	'ssfuckk',
	'ssfuuck',
	'sshag',
	'sshat',
	'sshav',
	'sshhit',
	'sshiit',
	'sshit',
	'sshita',
	'sshitad',
	'sshitca',
	'sshite',
	'sshited',
	'sshiter',
	'sshitfi',
	'sshitin',
	'sshitit',
	'sshitol',
	'sshits',
	'sshitt',
	'sshitte',
	'sshittt',
	'sshitty',
	'sshity',
	'sshoot',
	'sshshit',
	'sskaank',
	'sskank',
	'sskankk',
	'sskanky',
	'sskannk',
	'sskkank',
	'sskum',
	'sslant',
	'sslav',
	'sslave',
	'sslime',
	'ssllut',
	'sslopey',
	'sslopy',
	'ssluat',
	'sslut',
	'ssluts',
	'sslutt',
	'sslutty',
	'ssluty',
	'ssluut',
	'ssmack',
	'ssmut',
	'ssnatch',
	'ssnigge',
	'ssnot',
	'ssob',
	'ssodom',
	'ssodomy',
	'ssooty',
	'ssos',
	'sspank',
	'ssperm',
	'sspic',
	'sspicc',
	'sspick',
	'sspig',
	'sspiic',
	'sspik',
	'sspit',
	'sspooge',
	'ssppic',
	'sspunk',
	'sspunky',
	'ssquaw',
	'sssfuck',
	'ssshhit',
	'ssshiit',
	'ssshit',
	'ssshitt',
	'ssskank',
	'ssslut',
	'ssspic',
	'sssshit',
	'ssssshit',
	'sssssshit',
	'sstiffy',
	'sstroke',
	'ssuck',
	'ssucker',
	'ssuckme',
	'sswalow',
	'sswhore',
	'stifffy',
	'stiffy',
	'stiffyy',
	'stiiffy',
	'strapon',
	'stringer',
	'stripclub',
	'stroke',
	'strokee',
	'stroking',
	'strokke',
	'strooke',
	'strroke',
	'sttiffy',
	'sttroke',
	'stupedfuck',
	'stupedfucker',
	'stupid',
	'stupidfuck',
	'stupidfuckar',
	'stupidfucke',
	'stupidfucker',
	'succk',
	'succker',
	'succkme',
	'suck',
	'suckdick',
	'suckeer',
	'sucker',
	'suckerr',
	'suckk',
	'suckker',
	'suckkme',
	'suckme',
	'suckmee',
	'suckmme',
	'suckmyass',
	'suckmydick',
	'suckmytit',
	'suckoff',
	'suicide',
	'sunufabitch',
	'sunufbitch',
	'suuck',
	'suucker',
	'suuckme',
	'swaalow',
	'swaatnass',
	'swallow',
	'swallower',
	'swaloow',
	'swalow',
	'swaloww',
	'swastika',
	'sweetness',
	'swwalow',
	'syphilis',
	'taaboo',
	'taaff',
	'taampon',
	'taantra',
	'taard',
	'tabboo',
	'taboo',
	'tabooo',
	'taff',
	'tafff',
	'tammpon',
	'tampon',
	'tamponn',
	'tampoon',
	'tamppon',
	'tanntra',
	'tantra',
	'tantraa',
	'tantrra',
	'tanttra',
	'tarbaby',
	'tard',
	'tardd',
	'tarrd',
	'teaat',
	'teat',
	'teatt',
	'teeat',
	'teeste',
	'terror',
	'terrorist',
	'tesste',
	'teste',
	'testee',
	'testicle',
	'testicles',
	'testte',
	'tetfuck',
	'tetfucken',
	'tetfucker',
	'thicklips',
	'thirdeye',
	'thirdleg',
	'threesome',
	'threeway',
	'tiinkle',
	'tiit',
	'tiitjob',
	'tiits',
	'tiittie',
	'tiitty',
	'timbarniggar',
	'timbernigge',
	'timbernigger',
	'tinkkle',
	'tinkle',
	'tinklee',
	'tinklle',
	'tinnkle',
	'tit',
	'titbitnipply',
	'titfuck',
	'titfuckar',
	'titfucke',
	'titfucker',
	'titfucki',
	'titfuckin',
	'titjjob',
	'titjob',
	'titjobb',
	'titjoob',
	'titlicker',
	'titlover',
	'tits',
	'titss',
	'titt',
	'tittie',
	'tittiee',
	'titties',
	'tittiie',
	'tittjob',
	'titts',
	'titttie',
	'tittty',
	'titty',
	'tittyy',
	'tnnt',
	'tnt',
	'tntt',
	'toilet',
	'tongethruster',
	'tongue',
	'tonguethrust',
	'tonguetramp',
	'toortur',
	'toosser',
	'torrtur',
	'torttur',
	'tortur',
	'torture',
	'torturr',
	'tortuur',
	'tosseer',
	'tosser',
	'tosserr',
	'tossser',
	'towelhead',
	'traamp',
	'traanny',
	'trailertrash',
	'trammp',
	'tramp',
	'trampp',
	'trannie',
	'trannny',
	'tranny',
	'trannyy',
	'transexual',
	'transsexual',
	'transvestite',
	'triplex',
	'trisexual',
	'trojaan',
	'trojan',
	'trojann',
	'trojjan',
	'troojan',
	'troots',
	'trots',
	'trotss',
	'trotts',
	'trramp',
	'trranny',
	'trrojan',
	'trrots',
	'ttaboo',
	'ttaff',
	'ttampon',
	'ttantra',
	'ttard',
	'tteat',
	'tteste',
	'ttinkle',
	'ttit',
	'ttitjob',
	'ttits',
	'ttittie',
	'ttitty',
	'ttnt',
	'ttortur',
	'ttosser',
	'ttramp',
	'ttranny',
	'ttrojan',
	'ttrots',
	'tttwat',
	'tturd',
	'tturnon',
	'ttwaat',
	'ttwat',
	'ttwatt',
	'ttwink',
	'ttwwat',
	'tuckahoe',
	'tunneloflove',
	'tupidfuck',
	'tupidfucker',
	'turd',
	'turdd',
	'turnnon',
	'turnon',
	'turnonn',
	'turnoon',
	'turrd',
	'turrnon',
	'tuurd',
	'tuurnon',
	'twaaat',
	'twaat',
	'twaatt',
	'twat',
	'twatt',
	'twattt',
	'twiink',
	'twink',
	'twinkie',
	'twinkk',
	'twinnk',
	'twobetwhore',
	'twobitwhore',
	'twwaat',
	'twwat',
	'twwatt',
	'twwink',
	'twwwat',
	'ucck',
	'uck',
	'uckdick',
	'uckingbitch',
	'uckk',
	'uckmyass',
	'uckmydick',
	'uckwhore',
	'uk',
	'ullshit',
	'umbaass',
	'umbass',
	'umbasss',
	'umbbass',
	'umbbitch',
	'umbfuck',
	'umblefuck',
	'umffuck',
	'umfucck',
	'umfuck',
	'umfuckk',
	'umfuuck',
	'ummbass',
	'ummfuck',
	'unffuck',
	'unfucck',
	'unfuck',
	'unfuckabl',
	'unfuckabla',
	'unfuckable',
	'unfuckeble',
	'unfuckk',
	'unfuuck',
	'unnfuck',
	'untfuck',
	'untfucker',
	'upskirt',
	'upthaass',
	'uptheass',
	'upthebutt',
	'uriine',
	'urinary',
	'urinate',
	'urine',
	'urinee',
	'urinne',
	'urrine',
	'usama',
	'ussyfucker',
	'uteerus',
	'uterrus',
	'uterus',
	'uteruss',
	'uteruus',
	'utfucker',
	'utt-fuck',
	'utt-fucker',
	'utt-fuckers',
	'utterus',
	'uttfuck',
	'uttfucker',
	'uttfuckers',
	'uuck',
	'uumbass',
	'uumfuck',
	'uunfuck',
	'uurine',
	'uuterus',
	'vaagina',
	'vaggina',
	'vagiina',
	'vagina',
	'vaginaa',
	'vaginal',
	'vaginna',
	'vatican',
	'vibbr',
	'vibr',
	'vibrater',
	'vibrator',
	'vibrr',
	'vietcong',
	'viibr',
	'viirgin',
	'violence',
	'virggin',
	'virgiin',
	'virgin',
	'virginbreaker',
	'virginn',
	'virrgin',
	'vomiit',
	'vomit',
	'vomitt',
	'vommit',
	'voomit',
	'vullva',
	'vulva',
	'vulvaa',
	'vulvva',
	'vuulva',
	'vvagina',
	'vvibr',
	'vvirgin',
	'vvomit',
	'vvulva',
	'waab',
	'waank',
	'waanker',
	'wab',
	'wabb',
	'wank',
	'wankeer',
	'wanker',
	'wankerr',
	'wanking',
	'wankk',
	'wankker',
	'wannk',
	'wannker',
	'waysted',
	'weapon',
	'weeenie',
	'weeewee',
	'weenie',
	'weeniee',
	'weeniie',
	'weennie',
	'weetb',
	'weetback',
	'weewee',
	'weeweee',
	'weewwee',
	'welfare',
	'wetb',
	'wetbaack',
	'wetbacck',
	'wetback',
	'wetbackk',
	'wetbb',
	'wetbback',
	'wetspot',
	'wettb',
	'wettback',
	'whaash',
	'whacker',
	'whash',
	'whashh',
	'whassh',
	'whhash',
	'whhhore',
	'whhit',
	'whhitey',
	'whhiz',
	'whhoore',
	'whhop',
	'whhore',
	'whhoree',
	'whhorre',
	'whigger',
	'whiit',
	'whiitey',
	'whiiz',
	'whiskaydick',
	'whiskey',
	'whiskeydick',
	'whiskydick',
	'whit',
	'whitaniggar',
	'whiteey',
	'whitenigge',
	'whitenigger',
	'whites',
	'whitetrash',
	'whitey',
	'whiteyy',
	'whittey',
	'whiz',
	'whizz',
	'whooore',
	'whoop',
	'whoore',
	'whooree',
	'whoorre',
	'whop',
	'whopp',
	'whorafuckar',
	'whore',
	'whoree',
	'whoreee',
	'whorefocker',
	'whorefucke',
	'whorefucker',
	'whorehoose',
	'whorehous',
	'whorehouse',
	'whorere',
	'whorerere',
	'whorererere',
	'whorerererere',
	'whorre',
	'whorree',
	'whorrre',
	'whurefucker',
	'whwhore',
	'whwhwhore',
	'whwhwhwhore',
	'whwhwhwhwhore',
	'wiggeer',
	'wigger',
	'wiggerr',
	'wiggger',
	'wiigger',
	'williewanker',
	'wn',
	'wobitwhore',
	'wog',
	'wogg',
	`women's`,
	'woog',
	'woop',
	'wop',
	'wopp',
	'wtf',
	'wtff',
	'wttf',
	'wuss',
	'wusss',
	'wuuss',
	'wuuzzie',
	'wuzzie',
	'wuzziee',
	'wuzziie',
	'wuzzzie',
	'wwab',
	'wwank',
	'wwanker',
	'wweenie',
	'wweewee',
	'wwetb',
	'wwetback',
	'wwhash',
	'wwhhore',
	'wwhit',
	'wwhitey',
	'wwhiz',
	'wwhoore',
	'wwhop',
	'wwhore',
	'wwhoree',
	'wwhorre',
	'wwigger',
	'wwog',
	'wwop',
	'wwtf',
	'wwuss',
	'wwuzzie',
	'wwwhore',
	'wwwwhore',
	'wwwwwhore',
	'wwwwwwhore',
	'xtc',
	'xtcc',
	'xttc',
	'xxtc',
	'xxx',
	'xxxx',
	'yankee',
	'yellowman',
	'zigaabo',
	'zigabbo',
	'zigabo',
	'zigaboo',
	'ziggabo',
	'ziigabo',
	'zipperhead',
	'zzigabo',
];

export default badwords;
